import * as React from 'react';
var defaults = {
  registerTarget: function () {
    return {
      current: null
    };
  },
  getTargets: function () {
    return {};
  }
};
/**
 * @protected
 */
var RefContext = React.createContext(defaults);
export var RefContextProvider = RefContext.Provider;
export var useRefContext = function () {
  return React.useContext(RefContext);
};